import type { infer as zInfer } from "zod";
import * as z from "zod";

export const getAmazonIntegration = {
  name: "getAmazonIntegration" as const,
  input: z.object({}),
  output: z.object({ hasIntegration: z.boolean() }),
};

export type AmazonIntegration = zInfer<typeof getAmazonIntegration.output>;
